
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signout-oidc",
      function () {
        return require("private-next-pages/signout-oidc.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signout-oidc"])
      });
    }
  